// eslint-disable-next-line jira/export/no-external-exports
export { DependencyLineContainer as default } from '@atlassian/jira-portfolio-3-dependency-lines';
